export const stickyHeaderStyles = {
  stickyHeaderCard: {
    position: 'sticky',
    top: '-24px',
    zIndex: 4,
    whiteSpace: 'nowrap',
    mt: 1,
    mb: 2,
    p: 2,
  },
  stickyHeader: {
    whiteSpace: 'pre-wrap',
    padding: 0,
  },
  title: {
    fontWeight: 'fontWeightRegular',
  },
  subheader: { fontSize: '0.875rem' },
};
